/**
 * Bangladesh gold & silver reference prices (BAJUS-style).
 * Update LAST_UPDATED whenever prices change.
 *
 * Prices are per VORI (11.664 g) in BDT — the BAJUS quoting convention.
 */

export const LAST_UPDATED = "2026-04-01";
export const SOURCE = "BAJUS (Bangladesh Jewellers Samity) — reference estimate";

export interface GoldPriceTable {
  gold22k: number; // BDT per vori
  gold21k: number;
  gold18k: number;
  goldTraditional: number; // sanatani / traditional
  silver: number; // per vori
}

export const DEFAULT_PRICES: GoldPriceTable = {
  gold22k: 172_000,
  gold21k: 164_000,
  gold18k: 140_000,
  goldTraditional: 116_000,
  silver: 2_800,
};

/** Per-gram price derived from per-vori. */
export function perGram(perVori: number): number {
  return perVori / 11.664;
}
